const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "last_news_label": {
    "fr": "Actualités"
  },
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "side_blocks": {
    "fr": [
      "42040547"
    ]
  },
  "mapbox_token": "pk.eyJ1Ijoia3dwMjAyMSIsImEiOiJja202aHkxc20wb2RnMnh1aTA4YTM0OTMwIn0.7Us7PsbmVW1knkEwde0htw",
  "fb_display": false,
  "search_placeholder": {
    "fr": ""
  },
  "display_contact": false,
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "search_title": {
    "fr": "Recherche"
  },
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form",
  "time_format": {
    "fr": "HH:mm"
  },
  "twitter_display": false,
  "website_name": "Keolis Santé",
  "api_url": "https://api-v2.mobireport.fr",
  "contact_label": {
    "fr": ""
  },
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "search_button_label": {
    "fr": "Rechercher"
  },
  "primary_color": {
    "red": 0,
    "blue": 193,
    "alpha": 255,
    "green": 147
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "contact_phone_number": {
    "fr": ""
  },
  "alt_text": {
    "fr": "Renseignements : "
  },
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "gradient_primary_color": {
    "red": 0,
    "blue": 125,
    "alpha": 255,
    "green": 95
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "search_icon_color": {
    "red": 255,
    "blue": 255,
    "alpha": 1,
    "green": 255
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "gradient_button_color": {
    "red": 0,
    "blue": 193,
    "alpha": 255,
    "green": 147
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "active_button_text_color": {
    "red": 255,
    "blue": 255,
    "alpha": 255,
    "green": 255
  },
  "search_token": "81d75a5820fe568bdc525c22e5d0cc",
  "secondary_color": {
    "red": 255,
    "blue": 255,
    "alpha": 255,
    "green": 255
  },
  "subsidiary_logo": {
    "path": "/57019/1638539131-keolis-sante-u-white.png",
    "format": "png",
    "size": 18556,
    "alt": "Keolis Santé",
    "title": "Keolis Santé",
    "width": 1535,
    "height": 528
  },
  "back_to_home_title": {
    "fr": "Keolis Web Passenger – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "piano_site_id": "639200",
  "google_tag_manager_id": "GTM-NZ4RXZX",
  "google_analytics_key": "UA-15538359-1",
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "actistat_key": "",
  "loader": {
    "path": "/57019/1693498451-loader-bleu-keolis.gif",
    "format": "gif",
    "size": 795545,
    "alt": "Page en chargement, veuillez patientez s'il vous plaît",
    "title": "Page en chargement",
    "width": 1080,
    "height": 1080
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [],
  "form_captcha_key": "6Lcd1DMjAAAAAEsHVSyCqBSA_c8IBpjJStjgY_pH",
  "updated_at": "2024-10-14T14:04:46.647+02:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://www.keolis-sante.fr/",
  "readOnlyApi": "54878acca03eaea50396e915afaba3"
}